export default {"src":"/_next/static/media/premiumtrustpilot.416b0ef4.svg","height":32,"width":141,"blurWidth":0,"blurHeight":0};